import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router'
import myConfig from './config.js'
import './main.scss'
import './uploader.scss'
import API from './api.js'
import pgStorage from './storage.js'
import APIUser from './apiUser.js'
import APIRole from './apiRole.js'
import APIRight from './apiRight.js'
import APICompany from './apiCompany'
import APIPaxConnect from './apiPaxConnect.js'

import Vuex from 'vuex' // I18N
import vuexI18n from 'vuex-i18n' // I18N
import myI18n from './components/i18n/i18n.js'
import('../node_modules/material-icons/iconfont/material-icons.css')
import DatetimePicker from 'vuetify-datetime-picker'
import ApiTemplates from "@/apiTemplates";
import ApiOfficeClient from "@/apiOfficeClient";
import LazyLoadDirective from "./directives/LazyLoadDirective";

// (Optional) import 'vuetify-datetime-picker/src/stylus/main.styl'

Vue.use(DatetimePicker)

Vue.directive("lazyload", LazyLoadDirective);
Vue.config.productionTip = false
Vue.prototype.$config = myConfig
Vue.prototype.$api = API
Vue.prototype.$eventHub = new Vue() // Global event bus
Vue.prototype.storage = pgStorage
Vue.prototype.$apiUser = APIUser
Vue.prototype.$apiRole = APIRole
Vue.prototype.$apiTemplate = ApiTemplates
Vue.prototype.$apiRight = APIRight
Vue.prototype.$apiCompany = APICompany
Vue.prototype.$apiPaxConnect = APIPaxConnect
Vue.prototype.$apiOfficeClient = ApiOfficeClient

// I18N
Vue.use(Vuex)
const store = new Vuex.Store()
Vue.use(vuexI18n.plugin, store)
Vue.use(myI18n)
// I18N ende


new Vue({
  vuetify,
  router: router,
  render: h => h(App)
}).$mount('#app')
